// ----------------------------------------------------------------------

function path(root: string, sublink: string) {
    return `${root}${sublink}`;
}

const ROOT_PATH = '';
const ROOT_DEMO = '/demo';
const ROOTS_AUTH = '/auth';
const ROOT_API_TEST = '/api-test';
// const ROOTS_DASH = '/dashboard';

// ----------------------------------------------------------------------


export const PATH_AUTH = {
    root: ROOTS_AUTH,
    signIn: '/sign-in',
    login: '/sign-in',
    signup: path(ROOTS_AUTH, '/register'),
    confirmation: path(ROOTS_AUTH, '/confirmation'),
    onboarding: path(ROOTS_AUTH, '/onboarding'),
    profileSetup: path(ROOTS_AUTH, '/profile-setup'),
    forgotPassword: path(ROOTS_AUTH, '/forgot-password'),
};

export const PATH_STATIC = {
    comingSoon: '/coming-soon',
    maintenance: '/maintenance',
    about: '/about-us',
    contact: '/contact-us',
    faqs: '/faqs',
    page403: '/403',
    page404: '/404',
    page500: '/500',
};


export const PATH_ROOT = {
    root: ROOT_PATH,
    permissionDenied: path(ROOT_PATH, '/permission-denied'),
    profile: path(ROOT_PATH, '/profile'),
    apiTest: ROOT_API_TEST,
    inbox: path(ROOT_PATH, '/inbox'),
    integrations: path(ROOT_PATH, '/integrations'),
    main: {
        rules: path(ROOT_PATH, '/rules'),
        manager: path(ROOT_PATH, '/manager'),
        vault: path(ROOT_PATH, '/vault'),
        dashboard: path(ROOT_PATH, '/dashboard'),
        analysis: path(ROOT_PATH, '/analysis'),
        profile: path(ROOT_PATH, '/profile'),
        comparison: path(ROOT_PATH, '/comparison'),
        contractIq: path(ROOT_PATH, '/contract-iq'),
        create: path(ROOT_PATH, '/create'),
        dealPipeline: path(ROOT_PATH, '/deal-pipeline'),
        deal: path(ROOT_PATH, '/deal'),
        newDeal: path(ROOT_PATH, '/new-deal'),
        people: path(ROOT_PATH, '/people'),
        inbox: path(ROOT_PATH, '/inbox'),
        calendar: path(ROOT_PATH, '/calendar'),
        deliveryManager: path(ROOT_PATH, '/delivery-manager'),
        integrations: path(ROOT_PATH, '/integrations'),
        chat: path(ROOT_PATH, '/chat'),
        portfolio: path(ROOT_PATH, '/portfolio'),
        composer: path(ROOT_PATH, '/composer'),
        },
    organization: {
        root: path(ROOT_PATH, '/org'),
        organizations: path(ROOT_PATH, '/organizations'),
        dashboard: path(ROOT_PATH, '/org/dashboard'),
        management: path(ROOT_PATH, '/org/manage'),
        settings: path(ROOT_PATH, '/org/settings'),
        members: path(ROOT_PATH, '/org/members'),
        invitations: path(ROOT_PATH, '/org/invitations'),
        roles: path(ROOT_PATH, '/org/roles'),
        integrations: path(ROOT_PATH, '/org/integrations'),
    },
    settings: {
        root: path(ROOT_PATH, '/settings'),
        profile: path(ROOT_PATH, '/settings/profile'),
        sessions: path(ROOT_PATH, '/settings/sessions'),
        notifications: path(ROOT_PATH, '/settings/notifications'),
        general: path(ROOT_PATH, '/settings/general'),
        members: path(ROOT_PATH, '/settings/members'),
        integrations: path(ROOT_PATH, '/settings/integrations'),
        plan: path(ROOT_PATH, '/settings/plan'),
    },
    demo: {
        root: ROOT_DEMO,
        welcome: path(ROOT_DEMO, '/welcome'),
        rules: path(ROOT_DEMO, '/rules'),
        interactive: path(ROOT_DEMO, '/interactive'),
        selector: path(ROOT_DEMO, '/selector'),
        dashboard: path(ROOT_DEMO, '/dashboard'),
        vault: path(ROOT_DEMO, '/vault'),
        analysis: path(ROOT_DEMO, '/analysis'),
        recording: path(ROOT_DEMO, '/recording'),
        deal: path(ROOT_DEMO, '/deal'),
        organizations: path(ROOT_DEMO, '/organizations'),
        organizationManagement: (orgId: string) => path(ROOT_DEMO, `/org/${orgId}/manage`),
        organizationSettings: (orgId: string) => path(ROOT_DEMO, `/org/${orgId}/settings`),
        organizationMembers: (orgId: string) => path(ROOT_DEMO, `/org/${orgId}/members`),
        organizationInvitations: (orgId: string) => path(ROOT_DEMO, `/org/${orgId}/invitations`),
        organizationRoles: (orgId: string) => path(ROOT_DEMO, `/org/${orgId}/roles`),
        organizationIntegrations: (orgId: string) => path(ROOT_DEMO, `/org/${orgId}/integrations`),
        composer: path(ROOT_DEMO, '/composer'),
        comparison: path(ROOT_DEMO, '/comparison'),
        dealComparison: path(ROOT_DEMO, '/deal-comparison'),
        contractIq: path(ROOT_DEMO, '/contract-iq'),
        dealPipeline: path(ROOT_DEMO, '/deal-pipeline'),
        newDeal: path(ROOT_DEMO, '/new-deal'),
        people: path(ROOT_DEMO, '/people'),
        inbox: path(ROOT_DEMO, '/inbox'),
        calendar: path(ROOT_DEMO, '/calendar'),
        deliveryManager: path(ROOT_DEMO, '/delivery-manager'),
        integrations: path(ROOT_DEMO, '/integrations'),
        chat: path(ROOT_DEMO, '/chat'),
        create: path(ROOT_DEMO, '/create'),
        profile: path(ROOT_DEMO, '/profile'),
        roster: path(ROOT_DEMO, '/roster'),
        rosterClient: (clientId: string) => path(ROOT_DEMO, `/roster/${clientId}`),
        settings: path(ROOT_DEMO, '/settings'),
        settingsProfile: path(ROOT_DEMO, '/settings/profile'),
        settingsSessions: path(ROOT_DEMO, '/settings/sessions'),
        settingsNotifications: path(ROOT_DEMO, '/settings/notifications'),
        settingsGeneral: path(ROOT_DEMO, '/settings/general'),
        settingsMembers: path(ROOT_DEMO, '/settings/members'),
        settingsIntegrations: path(ROOT_DEMO, '/settings/integrations'),
        settingsPlan: path(ROOT_DEMO, '/settings/plan'),
    }
};

export const DEFAULT_DASH_PATH = PATH_ROOT.organization.organizations;